<template>
  <div class="profile-wrapper" v-show="loadingPageOver">
    <w-navbar :icon="'iconchevron-left'" :cvShow="true"
              :nav_title="'基本信息'" @mobileLeftBtn="backToEditor" :right_btn_html="rightBtnHtml"
              @mobileRightBtn="complete"/>
    <w-loading v-if="loadingShow"/>
    <div class="info-list" v-if="!loadingShow || loadingOver">
      <w-cv-form :formList="baseProfile" :req="req">
        <div :slot="`suggest-${suggestField}`" v-if="suggest">
          <suggest-card @handleClose="changeSuggestState"/>
        </div>
      </w-cv-form>

      <!-- module 求职信息 -->
      <!-- <div class="more-info" v-show="intentionInformation.length && !isGrad">
        <p class="more-title headline">求职信息</p>
        <div v-for="info in intentionInformation" :key="info.id" class="info-item">
          <div class="info-link flex-start" @click="changePickerState(info)">
            <span class="profile-label">{{ info.labelCn }}</span>
            <input type="text" v-model="req[info.field]" v-if="info.type === 'input'" @blur="onBlur"
                   :placeholder="info.id === 6 ? info.placeholderAry[intentionIndex] : info.placeholderCn">
          </div>
        </div>
      </div> -->

      <!-- module 社交信息 -->
      <div class="more-info" v-show="relationshipInformation.length">
        <p class="more-title headline">社交信息</p>
        <div v-for="info in relationshipInformation" :key="info.id" class="info-item">
          <div class="info-link flex-start" @click="changePickerState(info)">
            <span class="profile-label">{{ info.labelCn }}</span>
            <input type="text" v-model="req[info.field]" v-if="info.type === 'input'" :placeholder="info.placeholderCn"
                   @blur="onBlur">
          </div>
        </div>
      </div>

      <!-- module 其他信息 -->
      <div class="more-info" v-show="otherInformation.length">
        <p class="more-title headline">其他信息</p>
        <div v-for="info in otherInformation" :key="info.id" class="info-item">
          <div class="info-link flex-start">
            <span class="profile-label">{{ info.labelCn }}</span>
            <input type="text" v-model="req[info.field]" v-if="info.type === 'input'" :placeholder="info.placeholderCn"
                   @blur="onBlur">
            <input type="text" v-model="req[info.field]" v-if="info.typeEn === 'input' && lang === 'en'"
                   :placeholder="info.placeholderEn" @blur="onBlur">
            <div v-if="info.type === 'picker' && lang === 'cn'" class="picker" @click="changePickerState(info)">
              <div class="title" :class="{'no-content': !req[info.field]}">
                {{ req[info.field] || info.placeholderCn }}
              </div>
            </div>
            <div v-if="info.type === 'datetime'" @click="changePickerState(info)" class="date-time-title title"
                 :class="{'no-content': !req[info.field]}">
              {{ (info.field === 'birthday' ? req[type] : req[info.field]) || info.placeholderCn }}
            </div>
          </div>
          <div v-if="info.field === 'birthday'" class="birth-or-age flex-end">
            <div class="flex-start extent-left birth-radio">
              <input class="w-radio" type="radio" name="extent" id="age" @change="changeRadio('age')"
                     :checked="type === 'age'" :style="radioStyle">
              <label for="age">年龄</label>
            </div>
            <div class="flex-start">
              <input class="w-radio" type="radio" name="extent" id="birthday-radio" @change="changeRadio('birthday')"
                     :checked="type === 'birthday'" :style="radioStyle">
              <label for="birthday-radio">生日</label>
            </div>
          </div>
        </div>
      </div>

      <!-- module 求职意向 -->
      <div class="more-info more-info-other">
        <p class="more-title headline">求职意向</p>
        <div v-for="(item, index) in intentionMenu" :key="`intentionMenu&${index}`" class="info-item">
          <div class="info-link flex-start" @click="toTargetPage(item)">
            <span class="profile-label">{{ item.title }}</span>
            <input type="text" v-model="cvIntentionData[item.field]" :placeholder="item.placeholder" v-if="item.type !=='intention-salary'" >
            <div class="input" :class="[!cvIntentionData[item.field] ? 'placeholder' : '']" v-else>
              {{cvIntentionData[item.field] || item.placeholder}}
            </div>
            <i class="iconfont iconGroup10" v-if="item.field === 'expected_salary' && cvIntentionData[item.field]" style="color: #9c9c9c" @click.stop="cvIntentionData[item.field] = ''"></i>
          </div>
        </div>
      </div>

      <!-- button 更多信息 -->
      <div class="more-information flex-center" @click="changeMoreState">
        <div class="more-btn flex-center">
          <span class="iconfont iconplus"/>
          <span class="text">更多信息</span>
        </div>
      </div>

    </div>
    <w-popup-show :state="moreState" @handleClose="changeMoreState">
      <div slot="content" class="more-container">
        <div class="header flex-between">
          <span class="title headline">更多信息</span>
          <span class="iconfont iconx" @click="changeMoreState"/>
        </div>
        <!-- <div class="information-container" v-if="!isGrad">
          <p class="sub-title">求职信息</p>
          <div class="func-list flex-start">
            <div class="func-item flex-center" v-for="item in intentionProfile" :key="item.id"
                 :class="{'func-active': item.active}" @click="addInfo(item, 'intentionInformation')">
              <span>{{ item.labelCn }}</span>
            </div>
          </div>
        </div> -->
        <div class="information-container">
          <p class="sub-title">社交信息</p>
          <div class="func-list flex-start">
            <div class="func-item flex-center" v-for="item in relationshipProfile" :key="item.id"
                 :class="{'func-active': item.active}" @click="addInfo(item, 'relationshipInformation')">
              <span>{{ item.labelCn }}</span>
            </div>
          </div>
        </div>
        <div class="information-container information-other">
          <p class="sub-title">其他信息</p>
          <div class="func-list flex-start">
            <div class="func-item flex-center func-item-other" v-for="item in otherProfile" :key="item.id"
                 :class="{'func-active': item.active}" @click="addInfo(item, 'otherInformation')">
              <!--              <span class="iconfont iconplus"/>-->
              <span>{{ item.labelCn }}</span>
            </div>
          </div>
        </div>
      </div>
    </w-popup-show>
  </div>
</template>

<script>
	import WLoading from '@/components/global/w-loading'
	import WCvForm from '@/components/cv/w-cv-form'
	import WNavbar from '@/components/global/w-navbar'
	import WPopupShow from '@/components/global/w-popup-show'
	import { baseProfile, relationshipProfile, otherProfile, intentionProfile } from '@/assets/json/cv'
	import { verifyRequired, setupWebViewJavascriptBridge } from '@/assets/js/utils'
	import { componentsMixin } from '@/assets/js/mixin/components'
	import { envMixin } from '@/assets/js/mixin/global'
	import { mapState, mapMutations, mapActions } from 'vuex'
	import { eventMixin } from '../../assets/js/mixin/global'
	import { moduleMixin } from '../../assets/js/mixin/cv'
  import salaryData from "@/assets/json/salary.json";

	let moment = require('moment')

  const intentionMenu = [
    {
      title: '当前状态',
      type: 'intention-state',
      field: 'current_job',
      placeholder: '如：在职'
    },
    {
      title: '期望职位',
      type: 'intention-job',
      field: 'exp_job',
      placeholder: '请填写期望职位'
    },
    {
      title: '意向城市',
      type: 'intention-city',
      field: 'exp_city',
      placeholder: '请填写意向城市'
    },
    {
      title: '期望薪资',
      type: 'intention-salary',
      field: 'expected_salary',
      placeholder: '请填写期望薪资'
    }
  ]

	export default {
		mixins: [ componentsMixin, envMixin, eventMixin, moduleMixin ],
		data () {
			return {
				baseProfile,
				intentionInformation: [],
				relationshipInformation: [],
				otherInformation: [],
				moreState: false,
				req: {},
				birthday: '',
				loadingShow: true,
				loadingOver: false,
				type: 'birthday',
				field: '',
				responseCode: null,
				radioStyle: {
					width: '14px',
					height: '14px'
				},
        intentionMenu: JSON.parse(JSON.stringify(intentionMenu)),
        intentionData: {
          current_job: '',
          expected_salary: '',
          exp_job: '',
          exp_city: '',
          city_id: '',
          profession_id: ''
        },
        cascadeData: salaryData.salary, //期望薪资
        selectedIndex: [10, 0],//默认选中的薪资范围 11k-12k
			}
		},
    created () {
      this.intentionData = this.cvIntentionData
      console.log('ccccccccccc============>', this.intentionData, this.cvIntentionData)
    },
		async mounted () {
			// this.showToast(`token=======${this._token}`)
			this._getProfileData()
			this.iosBridge()
		},
		beforeRouteLeave (to, from, next) {
			this.$db.ls.remove('req')
			next()
		},
		components: {
			WLoading,
			WCvForm,
			WNavbar,
			WPopupShow
		},
		computed: {
			...mapState('cv', [ 'cv', 'profiles', 'isFirstCvInfo', 'cvIntentionData']),

			token () {
				return this.$route.params.token
			},
      cvIntentionDataIsData () {
        let key = false
        for (let prop in this.cvIntentionData) {
          if (this.cvIntentionData[prop]) {
            key = true
          }
        }
        return key
      },
			intentionProfile () {
				return JSON.parse(JSON.stringify(intentionProfile))
			},
			relationshipProfile () {
				return JSON.parse(JSON.stringify(relationshipProfile))
			},
			otherProfile () {
				return JSON.parse(JSON.stringify(otherProfile))
			},
			intentionIndex () {
				let cvTypeAry = [ [ 'zero', 'aboard_ba', 'grad' ], [ 'stu' ], [ 'white', 'bank', 'programmer', 'product' ] ]
				let type = this.cv.basic_info.cv_type, cIndex
				cvTypeAry.forEach((item, index) => {
					item.forEach(val => {
						if (type.includes(val)) {
							cIndex = index
						}
					})
				})
				return cIndex
			},
			lang () {
				return this.cv.basic_info.lang
			},
			isGrad () {
				let { type } = this.cv.basic_info
				return type && (type.includes('grad') || type.includes('aboard'))
			}
		},
		methods: {
      ...mapMutations('cv', [ 'setCvIntentionData' ]),
			...mapActions('cv', [ 'getProfileData', 'createProfileData', 'updateProfileData', 'createCvDetail' ]),

      toTargetPage (data) {
        if (data.type !== 'intention-salary') {
          this.$router.replace(data.type)
        } else {
          this.selectSalaryFunc()
        }
      },
      selectSalaryFunc () {
        this.cascadePicker = this.$createCascadePicker({
          title: "",
          data: this.cascadeData,
          selectedIndex: this.selectedIndex,
          onSelect: this.selectHandle,
          onCancel: this.cancelHandle
        });
        this.cascadePicker.show()
      },
      selectHandle (index) {
        this.selectedIndex[0] = index[0] - 1
        this.selectedIndex[1] = index[1] - index[0] - 1
        let salaryStr = ''
        if (index[0] === 100) {
          salaryStr = '100k以上'
        } else {
          salaryStr = `${index[0]}k-${index[1]}k`
        }
        this.setCvIntentionData({
          ...this.cvIntentionData,
          expected_salary: salaryStr
        })
        console.log(salaryStr)
      },
			onBlur () {
				// window.scrollTo(44, 0)
			},
			// 返回事件
			backToEditor () {
				this.verifyData({ req: this.req })
			},
			iosBridge () {
				if (this.isIos) {
					let url = `${ process.env.VUE_APP_HOST }/cvs/${ this.token }/editor`
					this.registerBridge('iosReturnCvEditor', this.verifyData, { req: this.req }, { url })
					this.registerBridge('saveModule', this.complete, {}, { url })
					this.registerBridge('loadPageTitle', null, null, { name: '基本信息' })
				}
			},
			// 选择生日或者是年龄
			changeRadio (type) {
				this.type = type
			},
			// 更多信息状态
			changeMoreState () {
				if (this.isIos) window.scrollTo(0, 44)
				this.moreState = !this.moreState
			},
			// 生日 和 picker 的弹窗
			changePickerState (info) {
				if (this.isIos) window.scrollTo(0, 44)
				if (info.type === 'picker' && this.lang === 'cn') {
					this.field = info.field
					let selectedIndex = null, data = []
					if (info.id === 13) {
						let heights = Array.from({ length: 131 }, (item, index) => {
							return { text: (index + 100).toString(), value: (index + 100).toString() }
						})
						data = [ heights, [ { text: 'cm', value: 'cm' } ] ]
						selectedIndex = this.req[info.field] ? [ [ heights.findIndex(v => v.value === this.req[info.field].replace(/\s+/g, '').slice(0, -2)) ], [ 0 ] ] : [ [ 60 ], [ 0 ] ]
					} else if (info.id === 14) {
						let weights = Array.from({ length: 121 }, (item, index) => {
							return { text: (index + 30).toString(), value: (index + 30).toString() }
						})
						data = [ weights, [ { text: 'kg', value: 'kg' } ] ]
						selectedIndex = this.req[info.field] ? [ [ weights.findIndex(v => v.value === this.req[info.field].replace(/\s+/g, '').slice(0, -2)) ], [ 0 ] ] : [ [ 30 ], [ 0 ] ]
					} else {
						data = [ info.pickerData ]
						selectedIndex = this.req[info.field] ? [ info.pickerData.findIndex(v => v.value.includes(this.req[info.field])) ] : [ info.selectedIndex ]
					}
					this.$createPicker({
						data,
						onSelect: this.pickerSelect,
						selectedIndex
					}).show()
				} else if (info.type === 'datetime') {
					this.datePicker = this.$createDatePicker({
						min: new Date('1950-01'),
						max: new Date(moment().format('YYYY-MM')),
						startColumn: 'year',
						columnCount: 2,
						value: this.req.birthday ? new Date(this.req.birthday) : new Date(`${ moment().subtract(22, 'year').format('YYYY') }-06`),
						format: {
							month: 'MM',
							date: 'DD'
						},
						onSelect: this.dateSelect,
					})
					this.datePicker.show()
				}
			},
			// picker选择的时候
			pickerSelect (value) {
				this.req[this.field] = value.join(' ')
			},
			// 时间选择的时候的问题
			dateSelect (date, val, text) {
				this.req.birthday = text.join('-')
				this.req.age = `${ moment().diff(date, 'year') }${ this.lang === 'cn' ? '岁' : '' }`
			},
			// 增加一个info
			addInfo (item, arr) {
				item.active = !item.active
				if (item.active) {
					this[arr].push(item)
				} else {
					this[arr] = this[arr].filter(v => v.id !== item.id)
					// this.req[item.field] = ''
				}
				this.changeMoreState()
				this.$forceUpdate()
			},
			// 初始化给弹窗中的tag加上选中样式后把对应的值放到对应的数组中
			_dealData () {
				this.intentionProfile.forEach(item => {
					if (item.active) this.intentionInformation.push(item)
				})
				this.relationshipProfile.forEach(item => {
					if (item.active) this.relationshipInformation.push(item)
				})
				this.otherProfile.forEach(item => {
					if (item.active) this.otherInformation.push(item)
				})
			},
			// 初始化内容
			_dealActive (req, arr) {
				arr.forEach(item => {
					if (req[item.field]) item.active = true
				})
			},
			// 获取profiles数据
			async _getProfileData () {
				this.responseCode = await this.getProfileData()
				if (this.profiles && Object.keys(this.profiles).length) {
					this.req = this.profiles

          if (!this.cvIntentionDataIsData) {
            this.setCvIntentionData({
              current_job: this.profiles.current_job,
              expected_salary: this.profiles.expected_salary,
              exp_job: this.profiles.exp_job,
              exp_city: this.profiles.exp_city,
              city_id: this.profiles.city_id,
              profession_id: this.profiles.profession_id
            })
          }

					if (this.req.birthday) {
						this.req.age = `${ moment().diff(this.req.birthday, 'year') }${ this.lang === 'cn' ? '岁' : '' }`
						this.req.birthday = moment(this.req.birthday).format('YYYY-MM')
					}
					this._dealActive(this.req, this.intentionProfile)
					this._dealActive(this.req, this.relationshipProfile)
					this._dealActive(this.req, this.otherProfile)
					this._dealData()
				} else {
					this.req = {
						birthday: null,
						height: null,
						weight: null,
						political_status: null,
						gender: null
					}
				}
				this.type = this.req.format_pref && this.req.format_pref.age_birthday ? this.req.format_pref.age_birthday.chosen : 'age'
        if(this.isFirstCvInfo.isFirst){
          this.req.phone = this.req.phone || this.isFirstCvInfo.data.phone || ''
        }
				this.$db.ls.set('req', this.req)
				this.loadingShow = false
				this.loadingOver = true
			},
			// 点击保存事件
			async complete () {
        console.log(this.cv)
				let { kind } = this.cv.basic_info
				let req = JSON.parse(JSON.stringify(this.req))
				let emailExp = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i
				let required = [
					{ val: req.username, message: '请填写姓名' },
					{ val: req.phone, message: '请填写电话' },
					{ val: req.email, message: '请填写邮箱' }
				]
				if (verifyRequired(required)) {
					this.showToast(verifyRequired(required), 2000)
					return
				} else if (!emailExp.test(req.email)) {
					this.showToast('请填写正确格式邮箱', 2000)
					return
				}
				let infoKeys = [ 'username', 'phone', 'email' ]
				this.intentionProfile.forEach(item => {
					infoKeys.push(item.field)
					if (!item.active) req[item.field] = ''
				})
				this.relationshipProfile.forEach(item => {
					infoKeys.push(item.field)
					if (!item.active) req[item.field] = ''
				})
				this.otherProfile.forEach(item => {
					infoKeys.push(item.field)
					if (!item.active) req[item.field] = ''
				})
				for (let o in req) {
					if (!infoKeys.includes(o)) delete req[o]
				}
				let format_pref = {
					age_birthday: {
						chosen: this.type,
						date_format: this.type === 'birthday' ? 'yyyy_d' : ''
					}
				}
				for (let key in req) {
					if (!req[key]) req[key] = null
				}
				req.format_pref = format_pref
				req.birthday = req.birthday ? moment(req.birthday).format('YYYY-MM-DD') : null

        req = {
          ...req,
          ...this.cvIntentionData
        }

				this.loadingShow = true
				let code = '', token = this.token
				if (kind === 'template' || kind === 'sample') {
					this.cv.submodule_info.sections_position.forEach(item => delete item.title)
					let payload = JSON.parse(JSON.stringify(this.cv))
					payload.basic_info.source_cv_token = payload.basic_info.token
					payload.basic_info['sample_cv_source_token'] = payload.basic_info.token // 记录简历是否是从“大牛简历模板”还是从“八大模板”创建
					payload.basic_info.kind = null
					payload.basic_info.token = null
					let res = await this.createCvDetail(payload)
					if (res.code === 3001) {
						this.showToast(res.message)
						return
					}
					token = this.cv.basic_info.token
				}
				if (this.responseCode) {
					code = await this.createProfileData({ token, payload: req })
				} else {
					code = await this.updateProfileData({ token, payload: req })
				}
				if (code === 1000) {
          this.$fn.redirect(
            `${window.location.origin}/cvs/${ token }/editor`,
            () => {
              this.$router.replace(`/cvs/${ token }/editor`)
            }
          )
        }
			}
		}
	}
</script>
<style scoped lang="scss">
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .profile-wrapper {
    padding-top: 44px;
    background-color: $color-light;
    /*min-height: 100vh;*/
    box-sizing: border-box;
    @include ipx-content-bottom(78px);
    .info-list {
      /deep/ .list {
        border-bottom: 8px solid #f9f9f9;
        .list-item {
          &:last-child {
            .item-link {
              border-bottom: none;
            }
          }
        }
      }
      .more-info {
        padding: 24px 24px 8px;
        background-color: $color-light;
        border-bottom: 8px solid #f9f9f9;
        .more-title {
          margin-bottom: 10px;
        }
        .info-item {
          .info-link {
            height: 48px;
            border-bottom: 1px solid #eeeff0;
            display: flex;
            align-items: center;
            .title {
              padding-left: 18px;
              color: $color-title;
            }
            .no-content {
              // font-size: $font-size-medium-x;
              color: #bcbcbc;
            }
            .date-time-title {
              height: 48px;
              line-height: 48px;
            }
            .profile-label {
              width: 100px;
              white-space: nowrap;
              color: $color-dark-gray;
              font-size: $font-size-medium;
            }
            input, .input {
              color: $color-title;
              border: none !important;
              flex: 1;
              // font-size: $font-size-medium-x;
              &::placeholder, &.placeholder {
                color: #bcbcbc;
              }
            }
            .input{
              padding: 0 18px;
              border-radius: 2px;
              box-sizing: border-box;
              -webkit-appearance: none;
            }
          }
          .birth-or-age {
            padding-top: 8px;
            .birth-radio {
              margin-right: 30px;
            }
            label {
              color: $color-title;
            }
          }
          &:last-child {
            .info-link {
              border: none;
            }
          }
        }
      }
      .more-info-other {
        border: none;
      }
      .more-information {
        position: fixed;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        padding-bottom: 32px;
        width: 100vw;
        background-color: $color-light;
        .more-btn {
          background-color: #f4f4f4;
          color: $color-dark-gray;
          line-height: 16px;
          width: 90vw;
          height: 46px;
          border-radius: 2px;
        }
        .iconfont {
          font-weight: bold;
          margin-right: 10px;
          font-size: 18px;
        }
      }
    }
    .more-container {
      width: 100vw;
      padding-bottom: 20px;
      .header {
        padding: 24px 24px 12px;
        .iconfont {
          color: $color-light-gray;
        }
      }
      .information-container {
        padding: 0 26px;
        margin-top: 12px;
        .sub-title {
          color: $color-title;
          margin-bottom: 18px;
        }
        .func-list {
          flex-wrap: wrap;
          .func-item {
            padding: 0 16px;
            border-radius: 16px;
            height: 34px;
            border: 1px solid #dedfe1;
            color: $color-light-gray;
            margin-right: 12px;
            margin-bottom: 12px;
            .iconfont {
              font-size: 20px;
              font-weight: 600;
            }
          }
          .func-active {
            color: $color-light;
            background-color: $color-theme;
            border-color: transparent;
          }
          .func-item-other {
            /*margin-right: 0;*/
          }
        }
      }
      .information-other {
        margin-bottom: 0;
      }
    }
  }
  .ios-profile-wrapper {
    min-height: calc(100vh - 88px);
  }
</style>
